<template>
  <v-layout column>
    <!-- header -->
    <v-layout row wrap pl-4>
      <v-flex xs6>
        <v-tabs>
          <v-tab
            class="text-none"
            v-model="tab"
            @click="privateMissionsToShow()"
          >
            {{ $tc('missionPicker.privateMissions', privateMissions.length) }}
          </v-tab>
          <v-tab class="text-none" @click="publicMissionsToShow()">
            {{ $tc('missionPicker.publicMissions', publicMissions.length) }}
          </v-tab>
          <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>
      </v-flex>
      <!-- search -->
      <v-flex xs3>
        <v-text-field
          v-model="search"
          clearable
          :label="$t('missionPicker.searchLabel')"
          class="pt-2 searchFilterClass"
        ></v-text-field>
      </v-flex>
      <!-- lang -->
      <v-flex layout column align-center justify-center pt-2>
        <span class="chooseDisplayText">
          {{ $t('missionPicker.lang') }}
        </span>
        <v-flex layout row>
          <v-flex v-for="lang in langsEdition" :key="lang">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  style="width: 15px; height: 15px"
                  @click="selectLangSearch(lang)"
                >
                  <gb-flag
                    :code="lang === 'en' ? 'gb' : lang"
                    :size="lang === searchLang ? 'small' : 'mini'"
                  />
                </v-btn>
              </template>
              <span>
                {{ $tc('missionPicker.showLang', $t('languages.' + lang)) }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-flex>
      </v-flex>
      <!-- display grid -->
      <v-flex layout column align-center justify-center pt-2>
        <span class="chooseDisplayText">
          {{ $t('missionPicker.display') }}
        </span>
        <v-flex layout row>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="mt-0 ml-0 mr-0"
                @click="changeFull(false)"
                v-on="on"
              >
                <v-icon large :color="full ? 'grey lighten-2' : 'primary'">
                  mdi-view-module
                </v-icon>
              </v-btn>
            </template>
            <span> {{ $t('missionPicker.displayGeneral') }} </span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="mt-0 ml-0 mr-0"
                @click="changeFull(true)"
                v-on="on"
              >
                <v-icon large :color="full ? 'primary' : 'grey lighten-2'"
                  >mdi-view-sequential</v-icon
                >
              </v-btn>
            </template>
            <span> {{ $t('missionPicker.displayDetails') }}</span>
          </v-tooltip>
        </v-flex>
      </v-flex>
    </v-layout>
    <!-- list missions content -->
    <v-container grid-list-sm fluid class="MissionPicker__container">
      <v-flex
        row
        wrap
        v-if="showPrivateMissions"
        v-for="[key, path] in displayPath"
        :key="key"
      >
        <v-layout row wrap>
          <p class="indicationText">
            {{ path.name[langEdition] }}
            <v-icon v-if="key === currentPathId" color="primary"
              >mdi-bookmark-check</v-icon
            >
          </p>
        </v-layout>
        <v-layout row wrap>
          <mission-card
            v-for="mission in searchedPrivateMissions.filter((m) =>
              isInPath(m.key, path)
            )"
            :key="mission.key"
            :parent="'MissionPicker'"
            :langEdition="searchLang"
            :mission="mission"
            :isDeleteable="key === 'nopath'"
            :full="full"
            :isCardSelected="isSelected('private', mission.key)"
            @click="selectMission('private', mission.key)"
            @un-select="selectMission('private', mission.key)"
          />
        </v-layout>
        <v-divider />
        <v-flex
          layout
          column
          align-center
          justify-center
          pt-4
          v-if="searchedPrivateMissions.length < 1"
        >
          <v-flex
            v-if="privateMissions.length < 1"
            layout
            column
            align-center
            justify-center
            pt-4
          >
            <p class="indicationText">
              {{ $t('missionPicker.haveNoMissions') }}
            </p>
            <p class="indicationTextMissionPicker">
              <v-icon x-large color="grey lighten-2" class="mdi-rotate-90">
                mdi-subdirectory-arrow-left
              </v-icon>
              {{ $t('missionPicker.searchCommunity') }}
            </p>

            <p class="indicationTextMissionPicker">
              {{ $t('missionPicker.click') }}
              <v-icon x-large color="grey lighten-2" class="mdi-rotate-225">
                mdi-arrow-top-left
              </v-icon>
            </p>
          </v-flex>
          <v-flex pt-4 v-else>
            <p class="indicationText">
              {{ $t('missionPicker.foundNoMission') }}
            </p>
            <p class="indicationTextMissionPicker">
              {{ $t('missionPicker.create') }}
            </p>
          </v-flex>
        </v-flex>
      </v-flex>
      <v-layout row wrap v-if="showPublicMissions">
        <mission-card
          v-for="mission in searchedPublicMissions"
          :parent="'MissionPicker'"
          :langEdition="searchLang"
          :key="mission.key"
          :mission="mission"
          :full="full"
          :isCardSelected="isSelected('public', mission.key)"
          @click="selectMission('public', mission.key)"
        />
        <v-flex
          layout
          column
          align-center
          justify-center
          pt-4
          v-if="searchedPublicMissions.length < 1"
        >
          <v-flex pt-4>
            <p class="indicationText">
              {{ $t('missionPicker.foundNoMission') }}
            </p>
            <p class="indicationTextMissionPicker">
              {{ $t('missionPicker.create') }}
            </p>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import * as JsSearch from 'js-search';
import MissionCard from './MissionCard';

export default {
  name: 'MissionPicker',
  components: {
    MissionCard,
  },
  props: {
    missions: {
      type: Array,
      required: true,
    },
    parent: {
      type: String,
      default: null,
    },
    numberMissions: {
      type: Number,
      default: 0,
    },
    langEdition: {
      type: String,
      default: null,
    },
    isMissionPickerOpen: {
      type: Boolean,
      default: null,
    },
  },
  data: () => ({
    publicMissionsSelected: [],
    privateMissionsSelected: [],
    search: '',
    showPrivateMissions: true,
    showPublicMissions: false,
    tab: true,
    full: false,
    searchLang: null,
    langsEdition: ['fr', 'en'],
  }),
  created() {
    this.searchLang = this.langEdition;
  },
  computed: {
    paths() {
      const paths = this.$store.state.paths.paths;
      return paths;
    },
    currentPathId() {
      return this.$route.params.pathId;
    },
    fakePath() {
      if (
        !this.privateMissionsNotInAnyPath ||
        this.privateMissionsNotInAnyPath.length === 0
      )
        return null;
      return {
        name: { fr: 'autres missions', en: 'other missions' },
        missions: this.privateMissionsNotInAnyPath.map((m) => {
          return { missionId: m.key };
        }),
      };
    },
    displayPath() {
      return [...Object.entries(this.paths), ['nopath', this.fakePath]].filter(
        ([k, v]) => v !== null
      );
    },
    publicMissions() {
      let publicMissions = this.missions
        .filter((mission) => mission._index === 'public')
        .map((pm) => {
          if (pm.name[this.searchLang]) {
            pm.normalizedName = pm.name[this.searchLang]
              .toLowerCase()
              .normalize('NFD')
              .replace(/\p{Diacritic}/gu, '');
          }
          // console.log('pm:', pm, pm.name[this.searchLang]);
          return pm;
        });
      console.log('publicMissions:', publicMissions);
      return publicMissions;
      // return this.missions.filter(mission => mission._index==='public');
    },
    privateMissions() {
      let privateMissions = this.missions
        .filter((mission) => mission._index !== 'public')
        .map((pm) => {
          if (pm.name[this.searchLang]) {
            pm.normalizedName = pm.name[this.searchLang]
              .toLowerCase()
              .normalize('NFD')
              .replace(/\p{Diacritic}/gu, '');
          }
          //console.log('pm:', pm, pm.name[this.searchLang]);
          return pm;
        });
      console.log('privateMissions:', privateMissions);
      return privateMissions;
    },
    searchedPublicMissions() {
      if (!this.search) return this.publicMissions;
      return this.publicMissions.filter((pm) => this.filterSearch(pm));
    },
    searchedPrivateMissions() {
      if (!this.search) return this.privateMissions;
      return this.privateMissions.filter((pm) => this.filterSearch(pm));
    },
    selectedMissions() {
      return this.privateMissionsSelected.concat(this.publicMissionsSelected);
    },
    allMissionsInAllPaths() {
      return Object.values(this.paths)
        .map((p) => p.missions.map((m) => m.missionId))
        .flat();
    },
    privateMissionsNotInAnyPath() {
      return [
        ...new Set(
          this.privateMissions.filter(
            (el) => !this.allMissionsInAllPaths.includes(el.key)
          )
        ),
      ];
    },
  },
  methods: {
    isSelected(type, key) {
      if (type === 'private') {
        return this.privateMissionsSelected.includes(key);
      } else if (type === 'public') {
        return this.publicMissionsSelected.includes(key);
      }
    },
    selectMission(type, key) {
      if (type === 'public') {
        const index = this.publicMissionsSelected.indexOf(key);
        if (index === -1) {
          return this.publicMissionsSelected.push(key);
        }
        this.publicMissionsSelected.splice(index, 1);
      } else if (type === 'private') {
        const index = this.privateMissionsSelected.indexOf(key);
        if (index === -1) {
          return this.privateMissionsSelected.push(key);
        }
        this.privateMissionsSelected.splice(index, 1);
      }
    },
    /*async submitSelection() {
      console.log('submit selection', this.privateMissionsSelected)
      this.$emit('copyMissionToPath', this.copyPathId, this.mission, this.pathMission.missionId);
      
      this.$emit('submit', this.privateMissionsSelected.concat(this.publicMissionsSelected));
      this.privateMissionsSelected = [];
      this.publicMissionsSelected = [];

    },
    */
    privateMissionsToShow() {
      this.showPrivateMissions = true;
      this.showPublicMissions = false;
    },
    publicMissionsToShow() {
      this.showPublicMissions = true;
      this.showPrivateMissions = false;
    },
    filterSearch(mission) {
      return (
        mission.name[this.searchLang].includes(this.search.toLowerCase()) ||
        mission.normalizedName.includes(this.search.toLowerCase())
      );
    },
    changeFull(value) {
      this.full = value;
    },
    isInPath(missionId, path) {
      return path.missions.map((m) => m.missionId).includes(missionId);
    },
    selectLangSearch(lang) {
      this.searchLang = lang;
    },
  },
  watch: {
    selectedMissions(value) {
      this.$emit('update-missions-to-add', value);
      return value;
    },
    numberMissions(value) {
      this.publicMissionsSelected = [];
      this.privateMissionsSelected = [];
      return value;
    },
    langEdition(newValue) {
      this.searchLang = newValue;
      return newValue;
    },
    isMissionPickerOpen(newValue) {
      if (newValue === false) {
        //déselection quand on ferme
        this.publicMissionsSelected = [];
        this.privateMissionsSelected = [];
      }
      return newValue;
    },
  },
};
</script>

<style lang="sass">

.chooseDisplayText
  text-transform: uppercase;
  font-size: x-small;
  text-align: center;
  text-justify: center;

.indicationTextMissionPicker
  font-size: large;
  text-align: center;
  text-justify: center;
  line-height: 120%
  color: grey;

.MissionPicker__container
  max-height: 400px
  min-height: 400px
  overflow-y: scroll

.MissionPicker__mission
  cursor: pointer
  margin-left: 4px
  margin-right: 4px
  margin-top: 4px;
  margin-bottom: 4px;
.MissionPicker__mission:hover
  opacity: 0.8
.MissionPicker__mission--selected
  border: 4px solid #009999 !important
  cursor: pointer
.clickable
  cursor: copy

.viewBtn
  margin-top: 0px;
  margin-left: 0px;
  margin-right: 0px;

.searchFilterClass
  max-width: 170px
</style>
